var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',[_vm._v("code:"+_vm._s(_vm.vxCode))]),_c('div',{staticClass:"btn",on:{"click":_vm.handleEnroll}},[_vm._v("点击获取code")])])}
var staticRenderFns = []

export { render, staticRenderFns }